// TheLABrief - Landing Page with Sun and Rays
// Created: 2026-01-30

import React, { useState, useEffect } from 'react';
import './App.css';
import RotatingText from './components/RotatingText';
import LightRaysCustom from './components/LightRaysCustom';
import skylineImage from './la-skyline.png';

const SENTENCES = [
  "Discover the latest ",
  "We deliver your "
];

const WORDS_SENTENCE_A = [
  'news', 'stories', 'headlines', 'coverage', 'reporting', 
  'updates', 'culture', 'Hollywood', 'politics', 'city'
];

const WORDS_SENTENCE_B = [
  'news', 'stories', 'headlines', 'briefing', 'updates',
  'reporting', 'coverage', 'digest', 'brief', 'newsletter'
];

const SENTENCE_ENDINGS = [
  ".",
  " to your inbox daily."
];

function App() {
  const [selectedSentence, setSelectedSentence] = useState(0);

  useEffect(() => {
    setSelectedSentence(Math.floor(Math.random() * 2));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = e.target.querySelector('input').value;
    
    fetch('/api/subscribe.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    })
      .then(response => {
        if (response.ok) {
          alert('Thanks for subscribing!');
          e.target.reset();
        }
      })
      .catch(() => alert('Error. Please try again.'));
  };

  const currentWords = selectedSentence === 0 ? WORDS_SENTENCE_A : WORDS_SENTENCE_B;

  return (
    <div className="App">
      {/* Sun and Light Rays */}
      <div className="sun-container">
        <div className="sun"></div>
        <LightRaysCustom />
      </div>

      <header>
        <h1 className="title">THE<span className="la-text">LA</span>BRIEF</h1>
        <p className="subtitle">From the team behind your favorite LA newsletters.</p>
      </header>

      <main>
        <div className="tagline-container">
          <span className="tagline-text">{SENTENCES[selectedSentence]}</span>
          <RotatingText
            texts={currentWords}
            mainClassName="rotating-word"
            staggerFrom="last"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "-120%" }}
            staggerDuration={0.05}
            splitLevelClassName="overflow-hidden pb-1"
            transition={{ type: "spring", damping: 40, stiffness: 250 }}
            rotationInterval={2000}
          />
          <span className="tagline-text">{SENTENCE_ENDINGS[selectedSentence]}</span>
        </div>
        
        <form className="subscribe-form" onSubmit={handleSubmit}>
          <input type="email" placeholder="your email" required />
          <button type="submit">subscribe</button>
        </form>
      </main>

      <footer className="skyline-container">
        <div className="skyline" style={{ backgroundImage: `url(${skylineImage})` }}></div>
      </footer>
    </div>
  );
}

export default App;
